<template>
  <div class="w-full flex justify-center md:pt-12">
    <div
      class="w-full md:w-80% py-12 border border-border-10 rounded-2xl flex flex-col items-center gap-5"
    >
      <check-mark-icon />

      <h1 class="text-black-10 font-bold text-2xl mb-2">KYC Completed</h1>
      <p class="text-gray-muted text-sm md:text-base text-center mb-3 w-4/5">
        You have successfully completed your KYC. Click on the button below to
        go back to dashboard.
      </p>

      <button
        @click="goToDashboard"
        class="bg-primary hover:opacity-90 text-white text-sm md:text-base font-bold py-4 mt-3 px-10 rounded-lg outline-none"
        test-id="button"
      >
        Continue to Dashboard
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KycCompleted',
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue')
  },
  methods: {
    goToDashboard () {
      this.$router.replace('/dashboard')
    }
  }
}
</script>
